<template>
    <div>
      <v-overlay :value="overlay" absolute >
        <v-progress-circular indeterminate :size="OlSize" color="#EC0E83" width="8" class="text-center">
            <template v-slot:default> {{ overlayText }} </template>
        </v-progress-circular>
      </v-overlay>
      <v-card>
       
        <v-toolbar flat color="white">
          <v-toolbar-title>
            <v-icon class="mb-1">mdi-file-clock</v-icon>
            DAES PARA VALIDACION
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          
          <v-col cols="2">
            <v-btn small class="mx-2" color="blue" dark :to="`/lista_daes_gen`">
                 <v-icon left>mdi-arrow-left</v-icon> Daes Fincas
            </v-btn>
          </v-col>

          
          <v-col cols="3">
            <v-btn class="mx-4" small color="primary" @click="cargarArchivo()">
              <v-icon left>mdi-upload</v-icon> Importar DAEs
            </v-btn>
            <v-file-input
              style="display: none"
              id="imporatFi"
              class="pb-0 mb-0"
              label="Iportar desde archivo"
              v-model="archivoImp"
              @change="importarDaaes()"
            ></v-file-input>
          </v-col>
        </v-toolbar>
        
        <v-toolbar flat>
            <v-col cols="2">
                <v-text-field
                v-model="busquedaNumero"
                append-icon="mdi-magnify"
                label="Numero DAE"
                single-line
                class="mt-5"
                clearable
                @click:append="cargarLista"
                @keyup.enter="cargarLista"
                >
                </v-text-field>
            </v-col>
            <v-col cols="2">
                <v-text-field
                clearable
                v-model="busquedaExportador"
                append-icon="mdi-magnify"
                label="Exportador"
                single-line
                class="mt-5"
                @click:append="cargarLista"
                @keyup.enter="cargarLista"
                >
                </v-text-field>
            </v-col>

            <v-col cols="2">
                <v-text-field
                clearable
                v-model="busquedaDestino"
                append-icon="mdi-filter"
                label="Destino"
                single-line
                class="mt-5"
                @click:append="cargarLista"
                @keyup.enter="cargarLista"
                >
                </v-text-field>
            </v-col>

            <v-col cols="2">
                <v-text-field
                clearable
                v-model="busquedaRuc"
                append-icon="mdi-filter"
                label="RUC"
                single-line
                class="mt-5"
                @click:append="cargarLista"
                @keyup.enter="cargarLista"
                >
                </v-text-field>
            </v-col>
            <v-spacer></v-spacer>
        </v-toolbar>


      <v-data-table
        :headers="headers"
        :items="lista"
        :options.sync="options"
        :items-per-page="itemsPerPage"
        :page.sync="currentPage"
        :server-items-length="totalItems"
        class="elevation-1"
        @pagination="handlePageChange"
      >
        
        <template v-slot:no-data>
          No existen datos para mostrar.
        </template>
         <template v-slot:item.opciones="{item}">
            <v-btn icon color="green" @click="abrirFormDae(item.DAE_NUM)"><v-icon>mdi-eye</v-icon></v-btn>
        </template> 
      </v-data-table>
      </v-card>
  
      <!-- DIALOG DAE -->
      <v-dialog v-model="dialogDae"  max-width="550px">
        <v-card>
          <v-card-title>
            <v-icon class="mx-1">mdi-check</v-icon>
            <span class="headline">Datos DAE para validar</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="formDae">
                
                <v-row >
                  <v-col class="pt-0 pb-0" cols="8">
                    <v-text-field v-model="datosDae.DAE_NUM" label="Número">
                    </v-text-field>
                  </v-col>
                  <v-col class="pt-0 pb-0" cols="4">
                    <v-text-field
                      readonly
                      small
                      v-model="datosDae.RUC"
                      label="RUC"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pt-0 pb-0" cols="12">
                    <v-text-field 
                      label="Exportador"
                      v-model="datosDae.EXPORTADOR"
                      ></v-text-field>
                    
                  </v-col>
                 
                </v-row>
                <v-row>
                  
                  <v-col class="pt-0 pb-0" cols="6">
                    <v-text-field
                      class="md-12"
                      small
                      v-model="datosDae.FECHA_INICIO"
                      label="Fecha Inicio"
                  
                    ></v-text-field>
                  </v-col>
                  <v-col class="pt-0 pb-0" cols="6">
                    <v-text-field
                      readonly
                      class="md-12"
                      maxlength="8"
                      small
                      v-model="datosDae.FECHA_CADUCA"
                      label="Fecha caduca"
                  
                    ></v-text-field>
                  </v-col>
  

                  
                </v-row>
                
                <v-row >
                  <v-col class="py-0 my-0" cols="9">
                    <v-text-field
                      readonly
                      v-model="datosDae.ESTADO_TRAMITE"
                      label="Estado trámite"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0 my-0" cols="3">
                    <v-text-field
                      readonly
                      small
                      v-model="datosDae.DAE_REGULARIZADA"
                      label="DAE Regularizada"
                    />
                  </v-col>
                </v-row>
  
                <v-row>
                  <v-col class="py-0 my-0" cols="4">
                    <v-text-field
                      v-model="datosDae.FECHA_INGRESO"
                      label="Fecha de ingreso"
                    >

                    </v-text-field>
                    
                  </v-col>
                </v-row>

                <v-row class="py-0 my-0">
                  <v-col cols="4" class="py-0 my-0">
                  <v-text-field
                    v-model="datosDae.VALIDADA"
                    label="Validada"
                    readonly
                  ></v-text-field>
                  </v-col>

                  <v-col cols="4" class="py-0 my-0">
                    <v-text-field
                    readonly
                    v-model="datosDae.VALIDADA_FECHA"
                    label="Fecha de validación">

                    </v-text-field>
                  </v-col>

                  <v-col cols="4" class="py-0 my-0">
                      <v-text-field
                        v-model="datosDae.VALIDADA_USUARIO"
                        label="Validada por"
                        readonly
                      ></v-text-field>

                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-col class="text-center">              
              
              <v-btn @click="dialogDae = !dialogDae" small>
                <v-icon>mdi-cancel</v-icon> Salir
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  </template>
  
  <script>
  import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
  import Vue from "vue";
  import axios from "axios";
  
  export default {
    name: "DaesValidacionComponent",
    
    data: () => ({
      overlay: false,
      overlayText: "",
      OlSize : 96,
      headers: [
        { text: "Opciones", value: "opciones", width:40 },
        { text: "Exportador", value: "EXPORTADOR", width:200 },
        { text: "RUC" , value: "RUC", width:100},
        { text: "Numero", value: "DAE_NUM" },
        { text: "Destino", value: "DESTINO" },
        { text: "Desde", value: "FECHA_INICIO" },        
        { text: "Válido hasta", value: "FECHA_CADUCA" },

      ],
  
      requiredRule: [(v) => !!v || "El campo es requerido"],
      daeSecRule: [(v) => v.length == 8 || "El número de tener 8 digitos"],
      daeAnioRule: [(v) => v.length == 8 || "El número de tener 8 digitos"],
      daeMesRule: [
        (v) =>
          v >= new Date().getMonth() + 1 ||
          "El mes debe ser mayor o igual al actual",
      ],
  
      lista: [],
      paises: [],
      options: {},
  
      notifications: false,
  
      daeEdit: false,
      busquedaNumero: null,
      busquedaDestino: null,
      busquedaExportador: null,
      busquedaRuc: null,  

      formDaeTitulo: "",
      dialogDae: false,
      datosDae: {
        daeId: "",
        daeDestino: "",
        anio: "",
        mes: "",
        desde: "",
        hasta: "",
        fincaId: "",
        daeNumAduana: "",
        daeNumAnio: "",
        daeNumRegimen: "40",
        daeNumSec: "",
        daeNum: "",
        codigoPais: "",
      },
  
      itemsPerPage: 20,
      pageCount: 1,
      totalItems: 0,
      currentPage: 1,
      
      archivoImp: null,
      fincas: [],
    }),
    computed: {
      ...mapState("master", ["loadingTable", "user", "months", "token", "url"]),
  
      ...mapGetters("access", []),
      numDae() {
        return (
          this.datosDae.daeNumAduana +
          "-" +
          this.datosDae.daeNumAnio +
          "-" +
          this.datosDae.daeNumRegimen +
          "-" +
          this.datosDae.daeNumSec
        );
      },
      
    },
    methods: {
      ...mapMutations("master", [
        "setUrl",
        "setOverlay",
        "setMenu",
        "setLoadingTable",
        "setTitleToolbar",
      ]),
  
      ...mapActions("master", ["requestApi", "alertNotification"]),
        
      /*guardarDae() {
        if (!this.$refs.formDae.validate()) {
          return;
        }
        if (this.daeEdit == false) {
          this.setUrl("api/dae");
          this.requestApi({
            method: "POST",
            data: {
              dae_num: this.numDae,
              fecha_caduca: this.datosDae.hasta,
              fecha_inicio: this.datosDae.desde,
              ente_id: this.datosDae.fincaId,
              finca_id: this.datosDae.fincaId,
              destino: this.datosDae.daeDestino,
              cod_pais: this.datosDae.codigoPais,
              mes: this.datosDae.mes,
              anio: this.datosDae.anio,
            },
          })
            .then((res) => {
              console.log(res);
              this.cargarLista();
            })
            .catch(() => {})
            .finally(() => {
              this.dialogDae = false;
            });
        }
        if (this.daeEdit == true) {
          this.setUrl("api/dae/" + this.datosDae.daeId);
          this.requestApi({
            method: "PUT",
            data: {
              dae_id: this.datosDae.daeId,
              dae_num: this.numDae,
              fecha_caduca: this.datosDae.hasta,
              fecha_inicio: this.datosDae.desde,
              ente_id: this.datosDae.fincaId,
              finca_id: this.datosDae.fincaId,
              destino: this.datosDae.daeDestino,
              cod_pais: this.datosDae.codigoPais,
              anio: this.datosDae.anio,
              mes: this.datosDae.mes,
            },
          })
            .then((res) => {
              //console.log(res);
              this.cargarLista();
              
            })
            .catch((error) => {
                this.overlay=false;
                this.dialogDae = false;
            })
            .finally(() => {
              this.overlay=false;
              this.dialogDae = false;
            });
        }
      },*/
  
      cargarLista() {
        this.overlay = true;
        this.overlayText = "cargando"
        this.OlSize = 120
        this.setLoadingTable(true);
        this.setUrl("api/lista-daes-validacion");
        this.requestApi({
          method: "GET",
          data: {
            pageCount: this.pageCount,
            itemsPerPage: this.itemsPerPage,
            page: this.currentPage,
            busquedaNumero: this.busquedaNumero,
            busquedaDestino: this.busquedaDestino,
            busquedaExportador: this.busquedaExportador,
            busquedaRuc: this.busquedaRuc
          },
        })
          .then((res) => {
            //console.log(res);
            this.lista = res.data.lista;
            //this.paises = res.data.paises;
            this.pageCount = res.data.pageCount;
            this.totalItems = res.data.totalItems;
            
            
          })
          .catch((error) => {
            this.overlay=false;
            //this.setLoadingTable(false);
          })
          .finally(() => {
            this.overlay=false;
            this.overlayText="";
            //this.setLoadingTable(false);

          });
      },
  
      abrirFormDae(daevId) {
        /*this.datosDae.daeId = "";
        this.datosDae.daeNum = "";
        this.datosDae.daeDestino = "";
        this.datosDae.codigoPais = "";
        this.datosDae.desde = "";
        this.datosDae.hasta = "";
        this.datosDae.fincaId = "";
        this.datosDae.daeNumAduana = "";
        this.datosDae.daeNumAnio = new Date().getFullYear().toString();
        this.datosDae.daeNumRegimen = "40";
        this.datosDae.daeNumSec = "";
        (this.datosDae.anio = new Date().getFullYear().toString()),
          (this.datosDae.mes = ("0" + (new Date().getMonth() + 1)).slice(-2)),
          (this.dialogDae = true);
        this.daeEdit = false;  
        this.formDaeTitulo = "Nueva DAE";*/
  
        //if (daeid) {
  
        this.setUrl("api/datos-dae-validacion");
        this.requestApi({
          method: "POST",
          data: {
            daeNum: daevId
          },
        })
          .then((res) => {
            //console.log(res.data.dae)
            /*if (daeid) {
              this.daeEdit = true;
              this.formDaeTitulo = "Editar DAE";
              this.datosDae.daeId = daeid;
              this.datosDae.daeNumAduana = res.data.dae.FUE.split("-")[0];
              this.datosDae.daeNumAnio = res.data.dae.FUE.split("-")[1];
              this.datosDae.daeNumRegimen = res.data.dae.FUE.split("-")[2];
              this.datosDae.daeNumSec = res.data.dae.FUE.split("-")[3];
  
              this.datosDae.daeNum = res.data.dae.FUE;
              this.datosDae.desde = res.data.dae.FECHA_INICIO;
              this.datosDae.hasta = res.data.dae.FECHA_CADUCA;
              this.datosDae.daeDestino = res.data.dae.DESTINO;
              this.datosDae.codigoPais = res.data.dae.COD_PAIS;
              this.datosDae.fincaId = res.data.dae.FINCA_ID;
            }
            this.fincas = res.data.fincas;*/
            this.datosDae = res.data[0]
            this.dialogDae = true;
          })
          .catch((error) => {})
          .finally(() => {});
        //}
      },
  
  /*    eliminarDae(permissionId) {
        Vue.swal({
          html: "Está seguro de eliminar el permiso?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cerrar",
          ...this.paramAlertQuestion,
        }).then((result) => {
          if (result.isConfirmed) {
            this.setUrl("user-security-group");
            this.requestApi({
              method: "DELETE",
              data: {
                securityGroupPermissionId: this.securityGroupId,
                permissionId: permissionId,
                typeDelete: "eliminarPermiso",
              },
            }).then((res) => {
              this.alertNotification({ param: { html: res.data.detail } });
              let obj = this.permisos.find(
                (e) => e.permission_id == permissionId
              );
              let index = this.permisos.indexOf(obj);
              this.permisos.splice(index, 1);
            });
          }
        });
      },*/
  
      cargarArchivo() {
        document.getElementById("imporatFi").click();
      },
      importarDaaes() {
        let formData = new FormData();
        formData.append("archivo", this.archivoImp);
        formData.append("user_name", this.user.user_login_id);
        //formData.append("cabecera_id", this.datosGuia.CABECERA_ID);
        //formData.append("cliente_id", this.datosGuia.CLIENTE_ID);
        //formData.append("awb", this.datosGuia.AWB);
        //console.log(this.archivoSelecionados);
        this.overlay = true;
        this.overlayText = "importado DAES"
        this.setUrl("api/importar-daes");
        //alert(this.token);
  
        axios
          .post(this.url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + this.token,
            },
          })
          .then((res) => {
            this.overlay = false;
            this.overlayText = "";
            
            this.alertNotification({
              param: {
                html: res.data.msg,
              },
            });
          })
          .catch((err) => {
            this.overlay = false;
            this.alertNotification({
              param: {
                html: err.data.msg,
              },
            });
          })
          .finally((err) => {
            this.overlay = false;
          });
      },
  
      handlePageChange() {
        this.cargarLista();        
      },
    },
    mounted() {
      //this.$vuetify.lang.current = 'es'
      this.setTitleToolbar("DAES PARA VALIDACION");
      this.cargarLista();
      
    },
    watch: {
      options: {
        handler() {
          this.cargarLista();
        },
        deep: true,
      },
    },
  };
  </script>
  